import { CatalogueService } from 'src/app/angularJS/services/catalogue/catalogue.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';

export class CatalogueCreateController {

  public static $inject = [
    '$state',
    'catalogueService',
    'UserMessages',
    'ACTToolbarService',
    'userService',
    '$translate'
  ];

  public currentLocale: string;
  public date: Date;
  public time: string;
  public selectedScheme: InterACT.Interfaces.Schemes.Scheme;
  public effectiveFromDate: Date;
  public catalogue: InterACT.Interfaces.Catalogues.Catalogue;

  constructor(
    private $state: ng.ui.IStateService,
    private catalogueService: CatalogueService,
    private UserMessages: UserMessagesService,
    private ActToolbarService: ACTToolbarService,
    userService: UserService,
    $translate: ng.translate.ITranslateService) {
    this.catalogue = <any>{};
    this.effectiveFromDate = undefined;
    this.currentLocale = $translate.use();
    this.selectedScheme = userService.selectedScheme;
    this.date = new Date();
    this.time = undefined;
    this.activate();
  }

  public createCatalogue = () => {
    const schemeLink: InterACT.Interfaces.Catalogues.ResourceLink = <any>{};
    schemeLink.abbreviation = this.selectedScheme.reference;
    schemeLink.link = '/schemes/' + this.selectedScheme.id;
    this.catalogue.scheme = schemeLink;

    const dateTime = this.date;
    if (this.time) {
      const time = this.time.split(':');
      dateTime.setHours(parseInt(time[0], 10), parseInt(time[1], 10));
    }
    this.catalogue.effectiveFrom = <any>(moment(dateTime).utc().format('YYYY-MM-DDTHH:mm') + 'Z');

    return this.catalogueService.create(this.catalogue)
      .then(() => {
        this.UserMessages.showToast('TOAST_MESSAGE.CATALOGUE.CREATED');
        this.exitCreateCatalogue();
      });
  }

  public exitCreateCatalogue = () => this.$state.go('catalogues.list');

  private activate() {
    this.ActToolbarService.getToolbar('primary')
      .then((toolbar) => {
        toolbar.setTitle('CATALOGUES');
      });
  }
}